export const DocumentMask = () => {
  const cyrillicChars = /[А-Яа-яЁёІіЇїЄє']/g;
  const latinAlphanumericChars = /[0-9a-zA-Z]/g;
  const digitChars = /[0-9]/g;
  const mixedChars = /[0-9a-zA-ZА-Яа-яЁёІіЇїЄє]/g;

  const filterChars = (value, regex) =>
    String(value).match(regex)?.join('') ?? '';

  const dashFormat = (value, firstLen, secondLen, charFilter) => {
    const clean = filterChars(value, charFilter);
    const first = clean.slice(0, firstLen);
    const second = clean.slice(firstLen, firstLen + secondLen);
    return second.length > 0 ? `${first}-${second}` : first;
  };

  const seriesMask = (documentId) => (value) => {
    if (!value) return value;

    switch (documentId) {
      case 'DOCUMENT_PASSPORT':
        return filterChars(value, cyrillicChars).slice(0, 2).toUpperCase();
      case 'DOCUMENT_ID_CARD':
        return dashFormat(value, 8, 5, digitChars);
      case 'DOCUMENT_ID_RESIDENCE_PERMIT':
        return dashFormat(value, 8, 5, mixedChars);
      case 'DOCUMENT_DRIVERS_LICENSE':
        return filterChars(value, mixedChars).slice(0, 3);
      case 'DOCUMENT_EXTERNAL_PASSPORT':
        return filterChars(value, latinAlphanumericChars).slice(0, 2).toUpperCase();
      case 'DOCUMENT_FOREIGN_PASSPORT':
      case 'DOCUMENT_BIRTH_CERTIFICATE':
        return filterChars(value, /[0-9a-zA-ZА-Яа-яЁёІіЇїЄє\-]/g).slice(0, 10).toUpperCase();
      case 'DOCUMENT_RESIDENCE_PERMIT':
        return filterChars(value, mixedChars).slice(0, 4);
      default:
        return filterChars(value, latinAlphanumericChars).slice(0, 4);
    }
  };

  const seriesLimit = (documentId) => {
    switch (documentId) {
      case 'DOCUMENT_ID_CARD':
      case 'DOCUMENT_ID_RESIDENCE_PERMIT':
        return 14;
      case 'DOCUMENT_PASSPORT':
        return 2;
      case 'DOCUMENT_DRIVERS_LICENSE':
        return 3;
      case 'DOCUMENT_EXTERNAL_PASSPORT':
        return 2;
      case 'DOCUMENT_FOREIGN_PASSPORT':
      case 'DOCUMENT_REGISTRATION_CARD':
      case 'DOCUMENT_RESIDENCE_PERMIT':
        return 4;
      case 'DOCUMENT_BIRTH_CERTIFICATE':
        return 10;
      default:
        return 4;
    }
  };

  const numberMask = (documentId) => (value) => {
    if (!value) return value;

    switch (documentId) {
      case 'DOCUMENT_PASSPORT':
      case 'DOCUMENT_ID_CARD':
      case 'DOCUMENT_DRIVERS_LICENSE':
      case 'DOCUMENT_EXTERNAL_PASSPORT':
        return filterChars(value, digitChars);
      case 'DOCUMENT_FOREIGN_PASSPORT':
      case 'DOCUMENT_RESIDENCE_PERMIT':
        return filterChars(value, mixedChars);
      default:
        return filterChars(value, latinAlphanumericChars);
    }
  };

  const numberLimit = (documentId) => {
    switch (documentId) {
      case 'DOCUMENT_PASSPORT':
        return 6;
      case 'DOCUMENT_ID_CARD':
        return 9;
      case 'DOCUMENT_DRIVERS_LICENSE':
        return 6;
      case 'DOCUMENT_EXTERNAL_PASSPORT':
        return 6;
      case 'DOCUMENT_FOREIGN_PASSPORT':
      case 'DOCUMENT_RESIDENCE_PERMIT':
        return 20;
      default:
        return 20;
    }
  };

  return { seriesMask, seriesLimit, numberMask, numberLimit };
};
